import { jsx as _jsx } from "react/jsx-runtime";
import { helpId } from '@rjsf/utils';
import { FormHelperText } from '@chakra-ui/react';
/** The `FieldHelpTemplate` component renders any help desired for a field
 *
 * @param props - The `FieldHelpProps` to be rendered
 */
export default function FieldHelpTemplate(props) {
    const { idSchema, help } = props;
    if (!help) {
        return null;
    }
    const id = helpId(idSchema);
    return _jsx(FormHelperText, { id: id, children: help });
}
//# sourceMappingURL=FieldHelpTemplate.js.map